import { render, staticRenderFns } from "./view.vue?vue&type=template&id=2cd9175f&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd9175f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cd9175f')) {
      api.createRecord('2cd9175f', component.options)
    } else {
      api.reload('2cd9175f', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=2cd9175f&scoped=true", function () {
      api.rerender('2cd9175f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/verify/plan/view.vue"
export default component.exports